import { Car, AlertTriangle } from 'lucide-react';
import {
  RouteResponse,
  isRouteResult,
  isRouteError,
} from '../../dayplanning/dayplanning.types';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface ReadOnlyRouteSegmentProps {
  route: RouteResponse | undefined;
  isLoading?: boolean;
}

export function ReadOnlyRouteSegment({
  route,
  isLoading,
}: ReadOnlyRouteSegmentProps) {
  // Render route info based on type
  const renderRouteInfo = () => {
    if (isLoading) {
      return <span className="text-muted-foreground/50">Calculating...</span>;
    }

    if (route && isRouteResult(route)) {
      return (
        <div className="flex items-center gap-3">
          <span>{(route.distance_km || 0).toFixed(1)} km</span>
          <span>·</span>
          <span>{Math.round(route.duration_minutes || 0)} min</span>
        </div>
      );
    }

    if (route && isRouteError(route)) {
      return (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="flex items-center gap-1 text-red-600 dark:text-red-500">
                <AlertTriangle className="h-3 w-3" />
                <span>Route failed</span>
              </span>
            </TooltipTrigger>
            <TooltipContent className="max-w-xs">
              <p>{route.error}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      );
    }

    return <span className="text-muted-foreground/50">No route</span>;
  };

  return (
    <div className="text-muted-foreground flex items-center gap-3 px-4 py-2 text-sm">
      <Car className="h-4 w-4 shrink-0" />
      {renderRouteInfo()}
    </div>
  );
}
